import { Type } from '@angular/core';
import { PlanningDataSource } from '@digiwall/goliath-documents/proxy';
import { PlanningDataSourceAdapter } from './planning-adapter';
import { ServiceWorkOrderPlanningAdapter } from './service-work-order/service-work-order-planning.adapter';
import { ServiceWorkOrderStepPlanningAdapter } from './service-work-order-step/service-work-order-step-planning.adapter';
import { ProductionFolderPlanningAdapter } from './production-folder/production-folder-planning.adapter';
import { ProductionStepPlanningAdapter } from './production-step/production-step-planning.adapter';

/**
 * Data sources with an implemented adapter. A configuration data source absent from this map renders a
 * "not yet available" placeholder on the board (Delivery and Reception land in later steps).
 * Adapters are `providedIn: 'root'`, so the shell resolves the instance through the injector.
 */
export const PLANNING_ADAPTERS: Partial<
  Record<PlanningDataSource, Type<PlanningDataSourceAdapter>>
> = {
  [PlanningDataSource.ServiceWorkOrder]: ServiceWorkOrderPlanningAdapter,
  [PlanningDataSource.ServiceWorkOrderStep]: ServiceWorkOrderStepPlanningAdapter,
  [PlanningDataSource.Production]: ProductionFolderPlanningAdapter,
  [PlanningDataSource.ProductionStep]: ProductionStepPlanningAdapter,
};
